import { MediaMatcher } from '@angular/cdk/layout';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { ChangeDetectorRef, Component } from '@angular/core';
import { catchError, filter, forkJoin, of, Subscription, VirtualAction } from 'rxjs';
import { UnileverService } from 'src/app/features/shared/services/ServiceCatalogEncapsulators/Unilever.service';
import { SessionService } from 'src/app/features/shared/services/Session.service';
import { environment } from 'src/environments/environment';
import { MapHelperService } from 'src/services/map-helper.service';
import { TerritoriesListItem, TerritoryDTO, TerritoryVirtualLocationsDTO } from '../../../../Models/TerritoriesListItem';
import { PanelTerritoriesService } from '../../../../services/Panel-Territories.service';
import { TerritoriesService } from '../../../../services/TerritoriesService.service';
import { TerritoryRouteTypeEnum } from '../../../../utilities/enums/TerritoriesEnum';
import { PanelEditTerritoriesService } from '../../../../services/Panel-Edit-Territories.service';
import { Feature, FeatureCollection } from '@turf/helpers';
import { EnumFeaturesActionsDestinations } from 'src/app/features/shared/helpers/enums/EnumFeaturesActionsDestinations';
import { SwalNotificationService } from 'src/app/features/shared/services/SwalNotification.service';

@Component({
  selector: 'territories-edit-panel',
  templateUrl: './territories-edit-panel.component.html',
  styleUrls: ['./territories-edit-panel.component.css']
})
export class TerritoriesEditPanelComponent {

  selectedTerritories: TerritoryDTO[];
  selectedTabIndex: number = 0;
  territoriesLocations: { [key: string]: TerritoryVirtualLocationsDTO[] } = {};
  territoriesLocationsTray: { [key: string]: TerritoryVirtualLocationsDTO[] } = {};

  territoriesGeoJsonBackup: any;
  territoriesLocationsGeoJsonBackup: any;
  territoriesLocationsBackup: { [key: string]: TerritoryVirtualLocationsDTO[] } = {};

  totalLocationsCount: number = 0;

  isPolygonDrawActive: boolean = false;
  
  public isLoading: boolean = true;
  filter: boolean = false;

  subscription_GetList: Subscription;
  subscription_getLoading: Subscription;
  subscription_SelectedTerritories: Subscription;
  subscription_GetFeatures: Subscription;

  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;
  fullScreen: boolean = false;

  polygonButtonMsg: string = "Selecciona varios puntos en el mapa para crear una figura y para finalizar da doble click sobre el mapa";
  isPolygonButtonMsgVisible : boolean = true;
  polygonFinishMsg: string = "Hacer doble clic para finalizar colocación de vertices y mover la figura.";

  // dummyData: LocationDTO[] = [
  //   { identifier: '30527886', description: 'Av. Juárez 123, Centro', cordsX: '-99.1332', cordsY: '19.4326' } as LocationDTO,
  //   { identifier: '30809551', description: 'Calle Reforma 456, Polanco', cordsX: '-99.1899', cordsY: '19.4340' } as LocationDTO,
  //   { identifier: '30809312', description: 'Insurgentes Sur 789, Roma', cordsX: '-99.1625', cordsY: '19.4200' } as LocationDTO,
  //   { identifier: '10650106', description: 'Av. Constituyentes 321, Lomas', cordsX: '-99.2500', cordsY: '19.4050' } as LocationDTO,
  //   { identifier: '30844315', description: 'Paseo de la Reforma 555, Chapultepec', cordsX: '-99.1837', cordsY: '19.4250' } as LocationDTO,
  // ];

  // dummyData2: LocationDTO[] = [
  //   { identifier: '40527886', description: 'Av. Juárez 123, Centro', cordsX: '-99.1332', cordsY: '19.4326' } as LocationDTO,
  //   { identifier: '40809551', description: 'Calle Reforma 456, Polanco', cordsX: '-99.1899', cordsY: '19.4340' } as LocationDTO,
  //   { identifier: '40809312', description: 'Insurgentes Sur 789, Roma', cordsX: '-99.1625', cordsY: '19.4200' } as LocationDTO,
  //   { identifier: '40650106', description: 'Av. Constituyentes 321, Lomas', cordsX: '-99.2500', cordsY: '19.4050' } as LocationDTO,
  // ];

  // dummyData3: LocationDTO[] = [
  //   { identifier: '90527886', description: 'Av. Juárez 123, Centro', cordsX: '-99.1332', cordsY: '19.4326' } as LocationDTO,
  //   { identifier: '90809551', description: 'Calle Reforma 456, Polanco', cordsX: '-99.1899', cordsY: '19.4340' } as LocationDTO,
  //   { identifier: '90809312', description: 'Insurgentes Sur 789, Roma', cordsX: '-99.1625', cordsY: '19.4200' } as LocationDTO,
  //   { identifier: '90650106', description: 'Av. Constituyentes 321, Lomas', cordsX: '-99.2500', cordsY: '19.4050' } as LocationDTO,
  //   { identifier: '90844315', description: 'Paseo de la Reforma 555, Chapultepec', cordsX: '-99.1837', cordsY: '19.4250' } as LocationDTO,
  // ];

  // fullDummyData = [...this.dummyData, ...this.dummyData2, ...this.dummyData3];

  // dummyDataGeoJson = {
  //   "type": "FeatureCollection",
  //   "features": [
  //     // Puntos para FRJQ1_MON (5 esquinas del polígono)
  //     {
  //       "type": "Feature",
  //       "properties": {
  //         "identifier": "30527886",
  //         "Description": "Esquina 1 - FRJQ1_MON",
  //         "Icon": "bussineLocation.png",
  //         "idTerritory": "FRJQ1_MON",
  //       },
  //       "geometry": {
  //         "type": "Point",
  //         "coordinates": [-99.1332, 19.4326]
  //       }
  //     },
  //     {
  //       "type": "Feature",
  //       "properties": {
  //         "identifier": "30809551",
  //         "Description": "Esquina 2 - FRJQ1_MON",
  //         "Icon": "bussineLocation.png",
  //         "idTerritory": "FRJQ1_MON",
  //       },
  //       "geometry": {
  //         "type": "Point",
  //         "coordinates": [-99.1899, 19.4340]
  //       }
  //     },
  //     {
  //       "type": "Feature",
  //       "properties": {
  //         "identifier": "30809312",
  //         "Description": "Esquina 3 - FRJQ1_MON",
  //         "Icon": "bussineLocation.png",
  //         "idTerritory": "FRJQ1_MON",
  //       },
  //       "geometry": {
  //         "type": "Point",
  //         "coordinates": [-99.2500, 19.4050]
  //       }
  //     },
  //     {
  //       "type": "Feature",
  //       "properties": {
  //         "identifier": "10650106",
  //         "Description": "Esquina 4 - FRJQ1_MON",
  //         "Icon": "bussineLocation.png",
  //         "idTerritory": "FRJQ1_MON",
  //       },
  //       "geometry": {
  //         "type": "Point",
  //         "coordinates": [-99.1625, 19.4200]
  //       }
  //     },
  //     {
  //       "type": "Feature",
  //       "properties": {
  //         "identifier": "30844315",
  //         "Description": "Esquina 5 - FRJQ1_MON",
  //         "Icon": "bussineLocation.png",
  //         "idTerritory": "FRJQ1_MON",
  //       },
  //       "geometry": {
  //         "type": "Point",
  //         "coordinates": [-99.1837, 19.4250]
  //       }
  //     },
  //     // Puntos para FRJQ2_MON (4 esquinas del polígono)
  //     {
  //       "type": "Feature",
  //       "properties": {
  //         "identifier": "40527886",
  //         "Description": "Esquina 1 - FRJQ2_MON",
  //         "Icon": "bussineLocation.png",
  //         "idTerritory": "FRJQ2_MON",
  //       },
  //       "geometry": {
  //         "type": "Point",
  //         "coordinates": [-99.20, 19.40]
  //       }
  //     },
  //     {
  //       "type": "Feature",
  //       "properties": {
  //         "identifier": "40809551",
  //         "Description": "Esquina 2 - FRJQ2_MON",
  //         "Icon": "bussineLocation.png",
  //         "idTerritory": "FRJQ2_MON",
  //       },
  //       "geometry": {
  //         "type": "Point",
  //         "coordinates": [-99.19, 19.40]
  //       }
  //     },
  //     {
  //       "type": "Feature",
  //       "properties": {
  //         "identifier": "40809312",
  //         "Description": "Esquina 3 - FRJQ2_MON",
  //         "Icon": "bussineLocation.png",
  //         "idTerritory": "FRJQ2_MON",
  //       },
  //       "geometry": {
  //         "type": "Point",
  //         "coordinates": [-99.19, 19.41]
  //       }
  //     },
  //     {
  //       "type": "Feature",
  //       "properties": {
  //         "identifier": "40650106",
  //         "Description": "Esquina 4 - FRJQ2_MON",
  //         "Icon": "bussineLocation.png",
  //         "idTerritory": "FRJQ2_MON",
  //       },
  //       "geometry": {
  //         "type": "Point",
  //         "coordinates": [-99.20, 19.41]
  //       }
  //     },
  //     // Puntos para FRJS_CEY (4 esquinas del polígono)
  //     {
  //       "type": "Feature",
  //       "properties": {
  //         "identifier": "90527886",
  //         "Description": "Esquina 1 - FRJS_CEY",
  //         "Icon": "bussineLocation.png",
  //         "idTerritory": "FRJS_CEY",
  //       },
  //       "geometry": {
  //         "type": "Point",
  //         "coordinates": [-99.17, 19.40]
  //       }
  //     },
  //     {
  //       "type": "Feature",
  //       "properties": {
  //         "identifier": "90809551",
  //         "Description": "Esquina 2 - FRJS_CEY",
  //         "Icon": "bussineLocation.png",
  //         "idTerritory": "FRJS_CEY",
  //       },
  //       "geometry": {
  //         "type": "Point",
  //         "coordinates": [-99.16, 19.40]
  //       }
  //     },
  //     {
  //       "type": "Feature",
  //       "properties": {
  //         "identifier": "90809312",
  //         "Description": "Esquina 3 - FRJS_CEY",
  //         "Icon": "bussineLocation.png",
  //         "idTerritory": "FRJS_CEY",
  //       },
  //       "geometry": {
  //         "type": "Point",
  //         "coordinates": [-99.16, 19.41]
  //       }
  //     },
  //     {
  //       "type": "Feature",
  //       "properties": {
  //         "identifier": "90650106",
  //         "Description": "Esquina 4 - FRJS_CEY",
  //         "Icon": "bussineLocation.png",
  //         "idTerritory": "FRJS_CEY",
  //       },
  //       "geometry": {
  //         "type": "Point",
  //         "coordinates": [-99.17, 19.41]
  //       }
  //     }
  //   ]
  // };

  // dummyPolygonGeoJson = {
  //   type: "FeatureCollection",
  //   features: [
  //     {
  //       type: "Feature",
  //       properties: { 
  //         idTerritory: "FRJQ1_MON", 
  //         saturation: 15, 
  //         routeType: TerritoryRouteTypeEnum.Furia_Roja 
  //       },
  //       geometry: {
  //         type: "Polygon",
  //         coordinates: [
  //           [
  //             [-99.1332, 19.4326],
  //             [-99.1899, 19.4340],
  //             [-99.2500, 19.4050],
  //             [-99.1625, 19.4200],
  //             [-99.1837, 19.4250],
  //             [-99.1332, 19.4326]
  //           ]
  //         ]
  //       }
  //     },
  //     {
  //       type: "Feature",
  //       properties: { idTerritory: "FRJQ2_MON", saturation: 90, routeType: TerritoryRouteTypeEnum.Reparto },
  //       geometry: {
  //         type: "Polygon",
  //         coordinates: [
  //           [
  //             [-99.20, 19.40],
  //             [-99.19, 19.40],
  //             [-99.19, 19.41],
  //             [-99.20, 19.41],
  //             [-99.20, 19.40]
  //           ]
  //         ]
  //       }
  //     },
  //     {
  //       type: "Feature",
  //       properties: { idTerritory: "FRJS_CEY", saturation: 40, routeType: TerritoryRouteTypeEnum.Preventa },
  //       geometry: {
  //         type: "Polygon",
  //         coordinates: [
  //           [
  //             [-99.17, 19.40],
  //             [-99.16, 19.40],
  //             [-99.16, 19.41],
  //             [-99.17, 19.41],
  //             [-99.17, 19.40]
  //           ]
  //         ]
  //       }
  //     }
  //   ]
  // };

  constructor(
    private sessionService: SessionService,
    private territoriesService: TerritoriesService,
    private panelEditTerritoriesService: PanelEditTerritoriesService,
    private mapHelperService: MapHelperService,
    private notifyService: SwalNotificationService,
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    private panelTerritoriesService: PanelTerritoriesService,
    private unileverService: UnileverService,
  ) {
    this.mobileQuery = media.matchMedia("(min-width: 761px)");
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);

    this.subscription_getLoading = this.panelEditTerritoriesService.getLoading().subscribe((data: boolean) => {
      this.isLoading = data;
    });

    this.subscription_SelectedTerritories = this.panelEditTerritoriesService.getSelectedLocations().subscribe((data: any) => {
      Object.keys(data).forEach(territoryId => {
        this.territoriesLocationsTray[territoryId] = [...data[territoryId]];
      });
    });

    this.subscription_GetFeatures = this.mapHelperService.featuresInsideArea$.pipe(
          filter(data => data && data.featureCollection.features.length > 0 && data.destination == EnumFeaturesActionsDestinations.Territories)
        ).subscribe(data => {
          const intersectedFeatures = data.featureCollection.features;
          if(!environment.production) console.log("cambio de features", intersectedFeatures);
          this.allocateLocationsToTray(intersectedFeatures);
          
          this.deactivatePolygonDraw();
          this.isPolygonDrawActive = false;
    });
  }

  ngOnInit(): void {
    this.panelEditTerritoriesService.setLoading(true);
    // this.GetTerritories();
    // this.CreateLayers();
    this.getTerritoryLocationsList();
  }

  onTabChanged(index: number) {
    this.selectedTabIndex = index;
  }

  ngAfterViewInit(): void {
  }

  ngOnDestroy() {
    if (this.subscription_GetList) this.subscription_GetList.unsubscribe();
    if (this.subscription_getLoading)
      this.subscription_getLoading.unsubscribe();
    if (this.subscription_SelectedTerritories)
      this.subscription_SelectedTerritories.unsubscribe();
    if (this.subscription_GetFeatures)
      this.subscription_GetFeatures.unsubscribe();

    this.panelEditTerritoriesService.destroyLayers();
    //  this.panelTerritoriesService.toggleTerritoryLayers(true);
    // this.panelEditTerritoriesService.removeFilters();
  }

  CreateLayers() {
    // this.panelEditTerritoriesService.initializeLayers();
  }

  getTerritoryLocationsList() {
    const data = this.panelEditTerritoriesService.getData();
    this.selectedTerritories = data.territoryItemList.map(territory => {
      return {
        idTerritory: territory.idTerritory,
        region: territory.region,
        zone: territory.zone,
        routeType: territory.routeType,
        visitDay: territory.visitDay,
        routeFrequency: territory.routeFrequency,
        saturation: territory.saturation,
        virtualLocationDTOs: []
      };
    });

    console.log("heeeelp selected territories", this. selectedTerritories);
    
    // Inicializar arrays para todos los territorios al inicio
    this.selectedTerritories.forEach(territory => {
      if (!this.territoriesLocationsTray[territory.idTerritory]) {
        this.territoriesLocationsTray[territory.idTerritory] = [];
      }
      if (!this.territoriesLocations[territory.idTerritory]) {
        this.territoriesLocations[territory.idTerritory] = [];
      }
      if (!this.territoriesLocationsBackup[territory.idTerritory]) {
        this.territoriesLocationsBackup[territory.idTerritory] = [];
      }
    });

    if (!environment.production) console.log("GetTerritoriesList", this.selectedTerritories);
    
    this.panelEditTerritoriesService.setLoading(true);


    const requests = this.selectedTerritories.map(territory => 
      this.unileverService.GetPlanningTerritoriesDetails(territory).pipe(
        catchError(error => {
          console.error(`Error al obtener detalles del territorio ${territory.idTerritory}:`, error);
          return of({ isSuccess: false, error });
        })
      )
    );
  
    this. subscription_GetList = forkJoin(requests).subscribe((results: any[]) => {
      const finalLocationsGeoJson = {
        type: "FeatureCollection",
        features: []
      };

      const finalPolygonGeoJson = {
        type: "FeatureCollection",
        features: []
      };

      results.forEach((data, index) => {
        if (data[0].planningTerritoryDTO && data[0].geoJsonTerritory && data[0]  .geoJsonLocations) {
          const territoryDetails: TerritoryDTO = data[0].planningTerritoryDTO;
          
          const filteredDetails = Object.entries(territoryDetails).reduce((acc, [key, value]) => {
            if (value !== null && value !== undefined) {
              acc[key] = value;
            }
            return acc;
          }, {} as any);
          
          this.selectedTerritories[index] = { ...this.selectedTerritories[index], ...filteredDetails };
          if (!environment.production) console.log(`Detalles del territorio ${this.selectedTerritories[index].idTerritory}:`, territoryDetails);

          const territoryGeoJson = JSON.parse(data[0].geoJsonTerritory || '{}');
          
          // Si solo hay un punto, crear un polígono pequeño alrededor
          if (territoryGeoJson.features && territoryGeoJson.features.length === 1) {
            const singleFeature = territoryGeoJson.features[0];
            if (singleFeature.geometry && singleFeature.geometry.type === 'Point') {
              const [lng, lat] = singleFeature.geometry.coordinates;
              const offset = 0.001;

              const properties = singleFeature.properties || {
                saturation: this.selectedTerritories[index].saturation ?  Number(this.selectedTerritories[index].saturation.replace("%", "")) : 0,
                routeType: this.selectedTerritories[index].routeType as TerritoryRouteTypeEnum,
                idTerritory: this.selectedTerritories[index].idTerritory,
                color: this.panelEditTerritoriesService.assignColor(this.selectedTerritories[index].idTerritory)
              };
              
              // Crear un polígono cuadrado alrededor del punto
              const polygonFeature = {
                type: 'Feature',
                properties: { ...properties },
                geometry: {
                  type: 'Polygon',
                  coordinates: [[
                    [lng - offset, lat - offset],
                    [lng + offset, lat - offset],
                    [lng + offset, lat + offset],
                    [lng - offset, lat + offset],
                    [lng - offset, lat - offset] 
                  ]]
                }
              };
              
              territoryGeoJson.features = [polygonFeature];
            }
          }
          
          territoryGeoJson.features.forEach((feature: any) => {
            console.log("heeeeeeeeeeeelp terriotio", feature, territoryGeoJson);
            feature.properties = feature.properties || {};
            (feature.properties as any).saturation = this.selectedTerritories[index].saturation ?  Number(this.selectedTerritories[index].saturation.replace("%", "")) : 0;
            (feature.properties as any).routeType = this.selectedTerritories[index].routeType as TerritoryRouteTypeEnum;
            (feature.properties as any).idTerritory = this.selectedTerritories[index].idTerritory;
            (feature.properties as any).color = this.panelEditTerritoriesService.assignColor(this.selectedTerritories[index].idTerritory);
          });
          if (!environment.production) console.log(`Detalles del geoJson del territorio ${this.selectedTerritories[index].idTerritory}:`, territoryGeoJson);
          if(territoryGeoJson.features.length > 0) 
            this.panelEditTerritoriesService.loadMorePolygonGeoJson(territoryGeoJson);

          territoryDetails.virtualLocationDTOs.forEach(VirtualLocation => {
            if (VirtualLocation) {
              if (!this.territoriesLocations[this.selectedTerritories[index].idTerritory]) {
                this.territoriesLocations[this.selectedTerritories[index].idTerritory] = [];
                this.territoriesLocationsBackup[this.selectedTerritories[index].idTerritory] = [];
              }
              if(!this.territoriesLocations[this.selectedTerritories[index].idTerritory].some(loc => loc.identifier === VirtualLocation.identifier)) {
                this.territoriesLocations[this.selectedTerritories[index].idTerritory].push(VirtualLocation);
                this.territoriesLocationsBackup[this.selectedTerritories[index].idTerritory].push(VirtualLocation);
              }
            }
          });

          const locationsGeoJson = JSON.parse(data[0].geoJsonLocations || '{}');
          locationsGeoJson.features.forEach((feature: any) => {
            const identifier = feature.properties?.Identifier;
            (feature.properties as any).identifier = identifier;
            (feature.properties as any).idTerritory = this.selectedTerritories[index].idTerritory;
            (feature.properties as any).color = this.panelEditTerritoriesService.assignColor(this.selectedTerritories[index].idTerritory);
          });
          if (!environment.production) console.log(`Detalles del geoJson de las ubicaciones del territorio ${this.selectedTerritories[index].idTerritory}:`, locationsGeoJson);
          if(locationsGeoJson.features.length > 0)
            this.panelEditTerritoriesService.loadMoreLocationGeoJson(locationsGeoJson);

          finalLocationsGeoJson.features.push(...locationsGeoJson.features);
          finalPolygonGeoJson.features.push(...territoryGeoJson.features);

        }else{
          console.error(`Error en los detalles del territorio ${this.selectedTerritories[index].idTerritory}:`, data[0].error);
        }
      });

      this.selectedTerritories.forEach(territory => {
        if (!this.territoriesLocationsTray[territory.idTerritory]) {
          this.territoriesLocationsTray[territory.idTerritory] = [];
        }
        if (!this.territoriesLocations[territory.idTerritory]) {
          this.territoriesLocations[territory.idTerritory] = [];
        }
      });


      this.territoriesLocationsGeoJsonBackup = finalLocationsGeoJson;
      this.panelEditTerritoriesService.setSelectedLocations(this.territoriesLocationsTray);
      this.mapHelperService.FitBounds(finalPolygonGeoJson);
      this.territoriesGeoJsonBackup = finalPolygonGeoJson;
      this.totalLocationsCount = this.getTotalLocationsCount();

      this.panelEditTerritoriesService.setLoading(false);
    },

    (error) => {
      console.error("Error al obtener detalles de los territorios:", error);
      this.panelEditTerritoriesService.setLoading(false);
    }
  
  );

  }

  // GetTerritoryLayer() {
  //   var selectedGeoJsonFeatures = [];

  //   const finalPolygonGeoJson = {
  //     type: "FeatureCollection",
  //     features: []
  //   };

  //   const finalLocationsGeoJson = {
  //     type: "FeatureCollection",
  //     features: []
  //   };

  //   this.selectedTerritories.forEach((territory, index) => {
  //       const feature = this.dummyPolygonGeoJson.features.find(feature => feature.properties.idTerritory === territory.idTerritory) || this.dummyPolygonGeoJson.features[index];
  //       if (feature) {
  //         // feature.properties.saturation = Number(territory.saturation.replace("%", ""));
  //         // feature.properties.routeType = territory.routeType as TerritoryRouteTypeEnum;
  //         // feature.properties.idTerritory = territory.idTerritory;
  //         // (feature.properties as any).color = this.panelEditTerritoriesService.assignColor(territory.idTerritory);
  //         // selectedGeoJsonFeatures.push(feature);

  //         // const polygonGeoJson = {
  //         //   type: "FeatureCollection",
  //         //   features: [feature]
  //         // }
  //         // this.territoriesLocationsTray[territory.idTerritory] = this.territoriesLocationsTray[territory.idTerritory] || [];
  //         // //this.panelEditTerritoriesService.loadMorePolygonGeoJson(polygonGeoJson);
  //         // finalPolygonGeoJson.features.push(feature);

          
  //         const dataGeoJsonFeatures = this.dummyDataGeoJson.features.filter(feature => feature.properties.idTerritory === territory.idTerritory) || [...this.dummyDataGeoJson.features.filter(feature => feature.properties.idTerritory === "FRJQ1_MON")];
  //         const dataIdentifiers = this.dummyDataGeoJson.features.filter(locFeature => locFeature.properties.idTerritory === feature.properties.idTerritory).map(feature => { return { identifier: feature.properties.identifier, cordX: feature.geometry.coordinates[0], cordY: feature.geometry.coordinates[1] }; });
  //         dataIdentifiers.forEach(identifierObject => {
  //           const location = this.fullDummyData.find(loc => loc.identifier === identifierObject.identifier);
  //           location.cordsX = identifierObject.cordX.toString();
  //           location.cordsY = identifierObject.cordY.toString();
  //           if (location) {
  //             if (!this.territoriesLocations[feature.properties.idTerritory]) {
  //               this.territoriesLocations[feature.properties.idTerritory] = [];
  //               this.territoriesLocationsBackup[feature.properties.idTerritory] = [];
  //             }
  //             if(!this.territoriesLocations[feature.properties.idTerritory].some(loc => loc.identifier === location.identifier)) {
  //               this.territoriesLocations[feature.properties.idTerritory].push(location);
  //               this.territoriesLocationsBackup[feature.properties.idTerritory].push(location);
  //             }
  //           }
  //         });
  //         console.log("territoriesLocations", this.territoriesLocations);
          

  //         dataGeoJsonFeatures.forEach(dataFeature => {
  //           dataFeature.properties.idTerritory = feature.properties.idTerritory;
  //           (dataFeature.properties as any).color = this.panelEditTerritoriesService.assignColor(feature.properties.idTerritory);
  //         });
  //         const pointGeoJson = {
  //           type: "FeatureCollection",
  //           features: dataGeoJsonFeatures
  //         }
  //         finalLocationsGeoJson.features.push(...dataGeoJsonFeatures);
  //         this.panelEditTerritoriesService.loadMoreLocationGeoJson(pointGeoJson);
  //         // this.panelTerritoriesService.locationsGeoJson[territory.idTerritory] = pointGeoJson;
  //       } else {
  //         if (!environment.production) console.log("No se encontró un feature para el territorio: ", territory);
  //       }
  //   });
    
  //   this.selectedTerritories.forEach(territory => {
  //     if (!this.territoriesLocationsTray[territory.idTerritory]) {
  //       this.territoriesLocationsTray[territory.idTerritory] = [];
  //     }
  //     if (!this.territoriesLocations[territory.idTerritory]) {
  //       this.territoriesLocations[territory.idTerritory] = [];
  //     }
  //   });
    
  //   this.territoriesLocationsGeoJsonBackup = finalLocationsGeoJson;
  //   this.panelEditTerritoriesService.setSelectedLocations(this.territoriesLocationsTray);
  //   // this.panelEditTerritoriesService.removeFilters();
  //   // this.panelEditTerritoriesService.addActiveTerritoryPolygonFilter(this.selectedTerritories[0].idTerritory);
  //   // this.panelEditTerritoriesService.addActiveTerritoryLocationFilter(this.selectedTerritories[0].idTerritory);
  //   this.mapHelperService.FitBounds(finalPolygonGeoJson);
  //   this.territoriesGeoJsonBackup = finalPolygonGeoJson;
  //   this.totalLocationsCount = this.getTotalLocationsCount();


  //   //implementacion real en su momento

  //   this.panelEditTerritoriesService.GetPlanningTerritoriesDetails(this.panelInternalLayerService.geofenceLayer).subscribe((data: any) => {
  //     if (data.isSuccess) {
  //       const territoryDetails = data.result;
  //       const locationsData = territoryDetails.locations as LocationMinDTO[];
  //       const locations: LocationDTO[] = locationsData.map(loc => ({
  //         identifier: loc.identifier,
  //         description: loc.description,
  //         cordsX: loc.cordsX,
  //         cordsY: loc.cordsY
  //       }));
  //     }
  //   });
  // }

  getTotalLocationsCount(): number {
    return Object.values(this.territoriesLocations).reduce((sum, locations) => sum + locations.length, 0);
  }

  dropLocation(event: CdkDragDrop<TerritoryVirtualLocationsDTO[]>, destinationTerritoryId: string): void {
    if (event.previousContainer === event.container) {
      
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      
      const movedItem = event.previousContainer.data[event.previousIndex];
      
      const sourceTerritoryId = this.selectedTerritories.find(
        t => this.territoriesLocationsTray[t.idTerritory] === event.previousContainer.data
      )?.idTerritory;

      if (!environment.production) {
        console.log("dropLocation - evento:", event);
        console.log("dropLocation - item:", movedItem);
        console.log("dropLocation - origen:", sourceTerritoryId, "destino:", destinationTerritoryId);
      }

      // Validar que tenemos un item y un origen
      if (!movedItem || !sourceTerritoryId) {
        console.error("No se pudo identificar el item o el territorio de origen");
        return;
      }

      // Asegurar que los arrays existen (aunque deberían estar inicializados)
      if (!this.territoriesLocationsTray[destinationTerritoryId]) {
        this.territoriesLocationsTray[destinationTerritoryId] = [];
      }
      if (!this.territoriesLocations[destinationTerritoryId]) {
        this.territoriesLocations[destinationTerritoryId] = [];
      }
      
      // se muere si uso el container data, asi que mejor fijo
      const sourceArray = this.territoriesLocationsTray[sourceTerritoryId];
      const destinationArray = this.territoriesLocationsTray[destinationTerritoryId];
      
      //modifica sólo le tray
      transferArrayItem(
        sourceArray,
        destinationArray,
        event.previousIndex,
        event.currentIndex
      );

      // y el interno
      if (!this.territoriesLocations[destinationTerritoryId].some(loc => loc.identifier === movedItem.identifier)) {
        this.territoriesLocations[destinationTerritoryId].push(movedItem);
      }

      // Remover del origen
      if (this.territoriesLocations[sourceTerritoryId]) {
        this.territoriesLocations[sourceTerritoryId] = this.territoriesLocations[sourceTerritoryId].filter(
          loc => loc.identifier !== movedItem.identifier
        );
      }
      
      this.totalLocationsCount = this.getTotalLocationsCount();
      
      if (!environment.production) {
        console.log("Tray despues del drop:", this.territoriesLocationsTray);
        console.log("Ubicaciones despues del drop:", this.territoriesLocations);
      }
      this.reorderTerritories();
    }
  }

  onDrop(event: CdkDragDrop<TerritoryVirtualLocationsDTO[]>, destinationTerritoryId: string): void {
    const dragData = (event.item.data as any);
    
    // este ignora si se dropea en el header, para consistencia
    if (event.container.id?.startsWith('header-')) 
      return;
    
    if (dragData?.isMoveAll) {
      this.moveAllLocations(dragData.territoryId, destinationTerritoryId);
    } else {
      this.dropLocation(event, destinationTerritoryId);
    }
  }

  moveAllLocations(sourceTerritoryId: string, destinationTerritoryId: string): void {
    
    if (sourceTerritoryId === destinationTerritoryId) {
      return;
    }

    const sourceLocations = this.territoriesLocationsTray[sourceTerritoryId];
    
    if (!sourceLocations || sourceLocations.length === 0) {
      return;
    }

    if (!this.territoriesLocationsTray[destinationTerritoryId]) {
      this.territoriesLocationsTray[destinationTerritoryId] = [];
    }
    if (!this.territoriesLocations[destinationTerritoryId]) {
      this.territoriesLocations[destinationTerritoryId] = [];
    }

    const locationsToMove = [...sourceLocations];

    // mover ubicaciones en el tray
    this.territoriesLocationsTray[destinationTerritoryId].push(...locationsToMove);
    this.territoriesLocationsTray[sourceTerritoryId] = [];

    // y después la interna
    locationsToMove.forEach(location => {
      if (!this.territoriesLocations[destinationTerritoryId].some(loc => loc.identifier === location.identifier)) {
        this.territoriesLocations[destinationTerritoryId].push(location);
      }

      if(this.territoriesLocations[sourceTerritoryId].some(loc => loc.identifier === location.identifier)) {
        this.territoriesLocations[sourceTerritoryId] = this.territoriesLocations[sourceTerritoryId].filter(
          loc => loc.identifier !== location.identifier
        );
      }
    });

    this.totalLocationsCount = this.getTotalLocationsCount();

    if (!environment.production) {
      console.log(`Movidas ${locationsToMove.length} ubicaciones de ${sourceTerritoryId} a ${destinationTerritoryId}`);
    }

    this.reorderTerritories();
  }

  removeLocation(territoryId: string, item: TerritoryVirtualLocationsDTO) {
    // quitar del tray
    this.territoriesLocationsTray[territoryId] = this.territoriesLocationsTray[territoryId].filter(location => location.identifier !== item.identifier);
    this.totalLocationsCount = this.getTotalLocationsCount();
    this.panelEditTerritoriesService.clearLocationsState(item.identifier);

    // o de la lista de ubicaciones
    // this.territoriesLocations[territoryId] = this.territoriesLocations[territoryId].filter(location => location.identifier !== item.identifier);
    // const newTerritoriesGeoJson = this.panelEditTerritoriesService.createReorderedGeoJson(this.territoriesLocations);
    // this.panelEditTerritoriesService.loadPolygonGeoJson(newTerritoriesGeoJson);
  }

  reorderTerritories() {
    const newTerritoriesGeoJson = this.panelEditTerritoriesService.createReorderedGeoJson(this.territoriesLocations);
    console.log("Nuevo GeoJSON después de reordenar:", newTerritoriesGeoJson);
    this.panelEditTerritoriesService.loadPolygonGeoJson(newTerritoriesGeoJson);
    
    this.updateEditedLocationsGeoJson();
  }

  updateEditedLocationsGeoJson() {
    const newLocationGeoJson: FeatureCollection = {
      type: "FeatureCollection",
      features: []
    };

    // se necesita un feature nuevo para cada ubicacion
    Object.keys(this.territoriesLocations).forEach(territoryId => {
      const locations = this.territoriesLocations[territoryId];
      const color = this.panelEditTerritoriesService.assignColor(territoryId);
      
      locations.forEach(location => {
        const feature: Feature = {
          type: "Feature",
          properties: {
            identifier: location.identifier,
            Description: location.description,
            Icon: "bussineLocation.png",
            idTerritory: territoryId,
            color: color
          },
          geometry: {
            type: "Point",
            coordinates: [parseFloat(location.cordsX), parseFloat(location.cordsY)]
          }
        } as Feature;
        
        newLocationGeoJson.features.push(feature);
      });
    });

    this.panelEditTerritoriesService.updateLocationGeoJsonPreservingStates(newLocationGeoJson);
    
    if (!environment.production) {
      console.log("GeoJSON de ubicaciones actualizado:", newLocationGeoJson);
    }
  }

  resetTerritoriesAndLocations(){
    this.territoriesLocations = JSON.parse(JSON.stringify(this.territoriesLocationsBackup));
    Object.keys(this.territoriesLocations).forEach(territoryId => {
      this.territoriesLocationsTray[territoryId] = [];
    });
    this.panelEditTerritoriesService.clearLocationsState();
    this.totalLocationsCount = this.getTotalLocationsCount();
    this.panelEditTerritoriesService.loadPolygonGeoJson(this.territoriesGeoJsonBackup);

    this.panelEditTerritoriesService.resetLocationGeoJson();
    this.panelEditTerritoriesService.loadMoreLocationGeoJson(this.territoriesLocationsGeoJsonBackup);
  }

  onCardClicked(item: TerritoryVirtualLocationsDTO) {
    this.panelEditTerritoriesService.openDetailsPopup(item.identifier, item.cordsX, item.cordsY);
  }

  allocateLocationsToTray(intersectedFeatures: Feature[]) {
    if (intersectedFeatures != null && intersectedFeatures.length > 0) {
      const existingLocationsByTerritory: { [key: string]: Set<string> } = {};
      
      Object.keys(this.territoriesLocationsTray).forEach(territoryId => {
        existingLocationsByTerritory[territoryId] = new Set<string>();
        
        this.territoriesLocationsTray[territoryId]?.forEach(loc => {
          existingLocationsByTerritory[territoryId].add(loc.identifier);
        });
      });

      const uniqueTerritoryLocations: { [key: string]: TerritoryVirtualLocationsDTO[] } = {};
      let uniqueLocationsCounter = 0;

      intersectedFeatures.forEach(element => {
        const identifier = element.properties?.identifier ? element.properties?.identifier : element.properties?.Identifier;
        const idTerritory = element.properties?.idTerritory;
        
        if (identifier && idTerritory && this.territoriesLocationsTray[idTerritory]) {
          
          if (!existingLocationsByTerritory[idTerritory]?.has(identifier)) {
            const newLocation: TerritoryVirtualLocationsDTO = {
              identifier: identifier,
              cordsX: (element.geometry as any)?.coordinates[0]?.toString() || "",
              cordsY: (element.geometry as any)?.coordinates[1]?.toString() || ""
            } as TerritoryVirtualLocationsDTO;
            
            if (!uniqueTerritoryLocations[idTerritory]) {
              uniqueTerritoryLocations[idTerritory] = [];
            }
            
            uniqueTerritoryLocations[idTerritory].push(newLocation);
            existingLocationsByTerritory[idTerritory].add(identifier);
            uniqueLocationsCounter++;

          }
        }
      });

      if (!environment.production) {
        console.log(`ubicaciones unicas: ${uniqueLocationsCounter}`);
      }

      if (uniqueLocationsCounter === 0) {
        return;
      }

      const resp = this.notifyService.confirmMessage(
        "Ubicaciones encontradas", `Se encontraron ${uniqueLocationsCounter} ubicaciones no asignadas dentro del territorio. ¿Deseas agregarlas a los territorios?`
      );
      
      resp.then((result) => {
        if (result.value) {
          this.panelEditTerritoriesService.addLocationsToSelected(uniqueTerritoryLocations);
        }
      });
    }
  }

  togglePolygonDraw() {
    if (this.isPolygonDrawActive) {
      this.deactivatePolygonDraw();
      this.isPolygonDrawActive = false;
    } else {
      this.activatePolygonDraw();
      this.isPolygonDrawActive = true;
    }
  }

  activatePolygonDraw() {
    this.panelEditTerritoriesService.activatePolygonDrawMode();
  }

  deactivatePolygonDraw() {
    this.panelEditTerritoriesService.deactivatePolygonDrawMode();
  }

  onVisibilityChange(isVisible: boolean) {
    this.isPolygonButtonMsgVisible = isVisible;
  }

  ClosePanel() {
    this.territoriesService.setVisiblePanelEditTerritories(false);
  }
}
